import { useDispatch } from "react-redux";
import { getShareLink, setSelectedChat, createProject, setSelectedProjectChat } from "../../lib/redux/actions";
import CreateProjectDialog from "./CreateProjectDialog";
import Logo from "../../assets/svg/daburgpt.png";
import editIcon from "../../assets/svg/addNew.svg";
import RenderSideBarItems from "./RenderSideBarItems";
import { useNavigate, useLocation } from "react-router-dom";
import { FolderPlus,  Folder,  } from "lucide-react";
import SearchChatDialog from "./SearchChatDialog";
import { useState } from "react";
import PropTypes from "prop-types";
import Accordion from "./Accordion";
import { GenerateImageIcon } from "../../assets/icons/GenerateImage";
import { GenerateVideoIcon } from "../../assets/icons/GenerateVideoIcon";
import { GenerateAudioIcon } from "../../assets/icons/GenerateAudioIcon";
import { GeneratePPTIcon } from "../../assets/icons/GeneratePPTIcon";
import { MeetingIcon } from "../../assets/icons/MeetingIcon";
import { WeatherAgentIcon } from "../../assets/icons/WeatherAgentIcon";
import { DeepSearchIcon } from "../../assets/icons/DeepSearchIcon";
import { SearchChatIcon } from "../../assets/icons/SearchChatIcon";



export default function Sidebar({
  isMobile,
  sidebarOpen,
  loading,
  error,
  recentChatsData,
  handleSelectChat,
  setChats,
  selectedChat,
  setPage,
  closeSidebar,
  handleSelectProjectChat,
  setProjectChats,
  fetchRecentChats
}) {
  const [openPopupId, setOpenPopupId] = useState(null);
  const [sharedLink, setSharedLink] = useState("");
  const dispatch = useDispatch();
  const router = useNavigate();
  const location = useLocation();

  const [isSearchDialogOpen, setIsSearchDialogOpen] = useState(false);
  const [isCreateProjectDialogOpen, setIsCreateProjectDialogOpen] = useState(false);



  const handleProjectCreated = async (newProject) => {
    try {
      const res = await createProject(newProject);
      return res.data;
    } catch (e) {
      console.log(e)
    }
  };

  const isAgentSelected = (path) => {
    return location.pathname === path;
  };

  const handleAgentClick = (path) => {
    // Clear selected chat when clicking an agent
    dispatch(setSelectedChat({}));
    setChats([]);
    router(path);
    if (isMobile) {
      closeSidebar();
    }
  };
  const getLinkShare = async () => {
    try {
      const res = await getShareLink(selectedChat._id);
      setSharedLink(res.data.url);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSearchClick = () => {
    setIsSearchDialogOpen(true);
    if (isMobile) {
      closeSidebar();
    }
  };

  const handleCloseSearchDialog = () => {
    setIsSearchDialogOpen(false);
  };

  let sidebarTranslateClass = "translate-x-0";

  if (isMobile) {
    sidebarTranslateClass = sidebarOpen ? "translate-x-0" : "-translate-x-full";
  }

  return (
    <div
      className={`${sidebarTranslateClass} transition-transform duration-300 fixed lg:relative w-72 h-full border-r border-gray-200 z-40 overflow-y-auto bg-white`}
    >
      <div className="p-4 flex flex-col gap-4 items-center justify-center">
        <div className="flex justify-center space-x-4">
          <img src={Logo} alt="Dabur Logo" className="w-[80px] h-[66px]" />
        </div>

        <div className="w-full">
          <button
            className="w-full flex mt-4   items-start justify-center gap-2 font-hel cursor-pointer font-bold bg-[#1B5C29] rounded-[10px] text-[#ffffff] py-[10px] px-4"
            onClick={() => {
              setChats([]);
              dispatch(setSelectedChat({}));
              dispatch(setPage(1));
              router(`/`);
            }}
          >
            <img src={editIcon} alt="edit-icon" className="w-5 h-5" />
            <span>New Chat</span>
          </button>
          <div className="mt-4">
            <Accordion title="Agents" defaultOpen={true}>
              <div className="flex flex-col gap-2">
             
                <button
                  className={`flex items-center gap-3 py-2 px-[20px] rounded-lg hover:bg-gray-100 transition ${isAgentSelected("/generate-image") ? "bg-[#1b5c2926]" : ""
                    }`}
                  onClick={() => handleAgentClick("/generate-image")}
                >
                  
                  <div className="w-[20px] h-[20px] flex items-center justify-center shrink-0">
                    <GenerateImageIcon
                      color={isAgentSelected("/generate-image") ? "#1B5C29" : "#000000"}
                    />
                  </div>
                  <span style={{ color:isAgentSelected("/generate-image") ? "#1B5C29" : "#000000" }} className="text-base  !text-[14px]  font-normal">
                    Generate Image
                  </span>
                </button>
                <button
                  className={`flex items-center gap-3 py-2 px-[20px] rounded-lg hover:bg-gray-100 transition ${isAgentSelected("/generate-video") ? "bg-[#1b5c2926]" : ""
                    }`}
                  onClick={() => handleAgentClick("/generate-video")}
                >

                 <div className="w-[20px] h-[20px] flex items-center justify-center shrink-0">
                  <GenerateVideoIcon
                    color={isAgentSelected("/generate-video") ? "#1B5C29" : "#000000"}
                  />
                </div>
                  <span style={{ color:isAgentSelected("/generate-video") ? "#1B5C29" : "#000000" }} className="text-base  !text-[14px] text-[#1B5C29] font-normal">
                    Generate Video
                  </span>
                </button>
                <button
                  className={`flex items-center gap-3 py-2 px-[20px] rounded-lg hover:bg-gray-100 transition ${isAgentSelected("/generate-audio") ? "bg-[#1b5c2926]" : ""
                    }`}
                  onClick={() => handleAgentClick("/generate-audio")}
                >
                <div className="w-[20px] h-[20px] flex items-center justify-center shrink-0">
                  <GenerateAudioIcon  color={isAgentSelected("/generate-audio") ? "#1B5C29" : "#000000"} />
                  </div>
                  <span style={{ color:isAgentSelected("/generate-audio") ? "#1B5C29" : "#000000" }} className="text-base !text-[14px]  font-normal">
                    Generate Audio
                  </span>
                </button>
                <button
                  className={`flex items-center gap-3 py-2 px-[20px] rounded-lg hover:bg-gray-100 transition ${isAgentSelected("/generate-presentation") ? "bg-[#1b5c2926]" : ""
                    }`}
                  onClick={() => handleAgentClick("/generate-presentation")}
                >
                <div className="w-[20px] h-[20px] flex items-center justify-center shrink-0">
                  <GeneratePPTIcon
                    color={isAgentSelected("/generate-presentation") ? "#1B5C29" : "#000000"}
                  />
                </div>
                  <span style={{ color:isAgentSelected("/generate-presentation") ? "#1B5C29" : "#000000" }} className="text-base  !text-[14px]  font-normal">
                    Generate Presentation
                  </span>
                </button>
                 <button
                className={`flex items-center gap-3 py-2 px-[20px] rounded-lg hover:bg-gray-100 transition ${
                  isAgentSelected("/meeting-transcript") ? "bg-[#1b5c2926]" : ""
                }`}
                onClick={() => handleAgentClick("/meeting-transcript")}
              >
                <div className="w-[20px] h-[20px] flex items-center justify-center shrink-0">
                  <MeetingIcon
                    color={isAgentSelected("/meeting-transcript") ? "#1B5C29" : "#000000"}
                  />
                </div>
                
                <span style={{ color:isAgentSelected("/meeting-transcript") ? "#1B5C29" : "#000000" }} className="text-base  !text-[14px]  font-normal">
                  Meeting Transcript
                </span>
              </button>
                <button
                  className={`flex items-center gap-3 py-2 px-[20px] rounded-lg hover:bg-gray-100 transition ${isAgentSelected("/weather-forecast") ? "bg-[#1b5c2926]" : ""
                    }`}
                  onClick={() => handleAgentClick("/weather-forecast")}
                >
                  <div className="w-[20px] h-[20px] flex items-center justify-center shrink-0">
                    <WeatherAgentIcon
                      color={isAgentSelected("/weather-forecast") ? "#1B5C29" : "#000000"}
                    />
                  </div>
                  <span style={{ color:isAgentSelected("/weather-forecast") ? "#1B5C29" : "#000000" }} className="text-base !text-[14px]  font-normal">
                    Weather Forecast
                  </span>
                </button>
                <button
                className={`flex items-center gap-3 py-2 px-[20px] rounded-lg hover:bg-gray-100 transition ${
                  isAgentSelected("/deep-search") ? "bg-[#1b5c2926]" : ""
                }`}
                onClick={() => handleAgentClick("/deep-search")}
              >
              
              <div className="w-5[20px] h-[20px] flex items-center justify-center shrink-0">
                <DeepSearchIcon
                  color={isAgentSelected("/deep-search") ? "#1B5C29" : "#000000"}
                />
              </div>
               
                <span style={{ color:isAgentSelected("/deep-search") ? "#1B5C29" : "#000000" }} className="text-base !text-[14px]  font-normal">
                  Deep Search
                </span>
                </button>
                <button
                  className="flex items-center gap-3 py-2 px-[20px] rounded-lg hover:bg-gray-100 transition"
                  onClick={handleSearchClick}
                >

                  <div className="w-[20px] h-[20px] flex items-center justify-center shrink-0">
                    <SearchChatIcon
                      color={isAgentSelected("/search-chat") ? "#1B5C29" : "#000000"}
                    />
                  </div>
                  <span style={{ color:isAgentSelected("/search-chat") ? "#1B5C29" : "#000000" }} className="text-base  !text-[14px]  font-normal">
                    Search Chat
                  </span>
                </button>
              </div>
            </Accordion>
          </div>
          <div className="">
            <Accordion title="Projects" defaultOpen={true}>
              <div className="flex flex-col">
                <button
                  className={`flex items-center gap-3 py-2 rounded-lg hover:bg-gray-100 transition `}
                  onClick={() => setIsCreateProjectDialogOpen(true)}
                >
                  <div
                    className="ml-2 "
                  >
                    <FolderPlus className="w-5 h-5 text-green-800" />
                  </div>
                  <span  className="text-base !text-[12px] text-black font-normal">
                    New Project
                  </span>
                </button>
                {/* Render Projects */}
                {recentChatsData?.projectsListing?.map((project) => {
                  const IconComponent = Folder;
                  return (
                    <>
                      <button
                        key={project._id}
                        className={`flex items-center gap-3 py-1 rounded-lg hover:bg-gray-100 transition ${location.pathname.endsWith(project._id) ? "bg-[#1b5c2926]" : ""}`}
                        onClick={() => {
                          // Clear selected chat when entering a project? Maybe.
                          dispatch(setSelectedProjectChat({}));
                          setProjectChats([]);
                          if (project?.projectType === "marketing") {
                            router(`/project/${project?.projectName}/marketing/${project?._id}`)
                          }
                          router(`/project/${encodeURIComponent(project?.projectName)}/${encodeURIComponent(project?.projectType)}/${project?._id}`);
                          if (isMobile) {
                            closeSidebar();
                          }
                        }}
                      >
                        <div className={`ml-4`}>
                          <IconComponent className="w-4 h-4" style={{ color: "#1B5C29" }} />
                        </div>
                        <span className="text-base !text-[12px] text-black font-normal">
                          {project?.projectName}
                        </span>
                      </button>

                      {project?.sessions?.length > 0 && (
                        <div className="ml-4 gap-1 flex flex-col">

                           <Accordion title="Recent" HeadingclassName="!text-[12px] !ml-6 !text-black !font-bold " defaultOpen={true}>
                      
                          {project?.sessions?.map((data) => {
                            const item = {
                              ...data,
                              name: project?.projectName,
                              projectType: project?.projectType,
                            }
                            return (
                              <RenderSideBarItems
                                key={item._id}
                                chat={item}
                                handleSelectProjectChat={handleSelectProjectChat}
                                selectedChat={selectedChat}
                                openPopupId={openPopupId}
                                setOpenPopupId={setOpenPopupId}
                                closeSidebar={closeSidebar}
                                getLinkShare={getLinkShare}
                                sharedLink={""}
                                isShowVerticalIcon={false}
                              />
                            )
                          })}
                           </Accordion>
                        </div>
                      )}
                    </>
                  );
                })}
              </div>
            </Accordion>
          </div>
        </div>
      </div>

      {/* Recent Chats Section */}
      <div className="p-4">
        {(() => {
          if (loading) {
            return (
              <div className="flex justify-center py-4">
                <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-green-500"></div>
              </div>
            );
          }

          if (error) {
            return <div className="text-red-500 text-sm p-2">{error}</div>;
          }

          return (
            <>
              <h3 className="text-xs font-bold mb-2 text-[#000000]">
                Today ({recentChatsData.today.length})
              </h3>
              <div>
                {recentChatsData.today.map((chat) => (
                  <RenderSideBarItems
                    key={chat._id}
                    chat={chat}
                    handleSelectChat={handleSelectChat}
                    selectedChat={selectedChat}
                    closeSidebar={closeSidebar}
                    openPopupId={openPopupId}
                    setOpenPopupId={setOpenPopupId}
                    getLinkShare={getLinkShare}
                    sharedLink={sharedLink}
                  />
                ))}
              </div>

              {recentChatsData.last7Days.length > 0 && (
                <>
                  <h3 className="text-xs font-bold mb-2 text-[#000000] mt-4">
                    Previous 7 Days ({recentChatsData.last7Days.length})
                  </h3>
                  <div>
                    {recentChatsData.last7Days.map((chat) => (
                      <RenderSideBarItems
                        key={chat._id}
                        chat={chat}
                        handleSelectChat={handleSelectChat}
                        selectedChat={selectedChat}
                        closeSidebar={closeSidebar}
                        openPopupId={openPopupId}
                        setOpenPopupId={setOpenPopupId}
                        getLinkShare={getLinkShare}
                        sharedLink={sharedLink}
                      />
                    ))}
                  </div>
                </>
              )}

              {recentChatsData.last30Days.length > 0 && (
                <>
                  <h3 className="text-xs font-bold mb-2 text-[#000000] mt-4">
                    Previous 30 Days ({recentChatsData.last30Days.length})
                  </h3>
                  <div>
                    {recentChatsData.last30Days.map((chat) => (
                      <RenderSideBarItems
                        key={chat._id}
                        chat={chat}
                        handleSelectChat={handleSelectChat}
                        selectedChat={selectedChat}
                        closeSidebar={closeSidebar}
                        openPopupId={openPopupId}
                        setOpenPopupId={setOpenPopupId}
                        getLinkShare={getLinkShare}
                        sharedLink={sharedLink}
                      />
                    ))}
                  </div>
                </>
              )}

              {recentChatsData.older.length > 0 && (
                <>
                  <h3 className="text-xs font-bold mb-2 text-[#000000] mt-4">
                    Older ({recentChatsData.older.length})
                  </h3>
                  <div>
                    {recentChatsData.older.map((chat) => (
                      <RenderSideBarItems
                        key={chat._id}
                        chat={chat}
                        handleSelectChat={handleSelectChat}
                        selectedChat={selectedChat}
                        closeSidebar={closeSidebar}
                        openPopupId={openPopupId}
                        setOpenPopupId={setOpenPopupId}
                        getLinkShare={getLinkShare}
                        sharedLink={sharedLink}
                      />
                    ))}
                  </div>
                </>
              )}
            </>
          );
        })()}
      </div>

      {/* Search Chat Dialog */}
      <SearchChatDialog
        open={isSearchDialogOpen}
        onClose={handleCloseSearchDialog}
        closeSidebar={closeSidebar}
      />

      <CreateProjectDialog
        open={isCreateProjectDialogOpen}
        onClose={() => setIsCreateProjectDialogOpen(false)}
        onProjectCreated={handleProjectCreated}
        fetchRecentChats={fetchRecentChats}
        setProjectChats={setProjectChats}
      />
    </div>
  );
}

Sidebar.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  sidebarOpen: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.any,
  recentChatsData: PropTypes.shape({
    today: PropTypes.array,
    last7Days: PropTypes.array,
    last30Days: PropTypes.array,
  }),
  handleSelectChat: PropTypes.func,
  setChats: PropTypes.func.isRequired,
  selectedChat: PropTypes.object,
  setPage: PropTypes.func.isRequired,
  closeSidebar: PropTypes.func.isRequired,
};
